import React, { useState, useEffect } from "react";
import { AlertCircle, Loader2 } from "lucide-react";
import { getQuota } from "../api/quotaAPi";

const QuotaList = ({ coursesId, setQuotaId, quotaId }) => {
  const [loading, setLoading] = useState(false);
  const [options, setOptions] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Reset states when course ID changes
    if (!coursesId) {
      setOptions([]);
      setQuotaId("");
      return;
    }
    
    const getQuotaData = async () => {
      try {
        setLoading(true);
        setError(null);
        
        const data = await getQuota(coursesId);
        
        if (Array.isArray(data) && data.length > 0) {
          setOptions(data);
          
          const isCurrentQuotaValid = data.some(quota => quota.quota_id === quotaId);
          if (!quotaId || !isCurrentQuotaValid) {
            setQuotaId(data[0].quota_id);
          }
        } else {
          setOptions([]);
          setQuotaId("");
        }
      } catch (err) {
        console.error("Error fetching quota data:", err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    getQuotaData();
  }, [coursesId]);

  const handleQuotaChange = (e) => {
    setQuotaId(e.target.value);
  };

  return (
    <div className="w-full space-y-2">
      <label 
        htmlFor="quota-select" 
        className="block text-sm font-medium text-gray-700"
      >
        Select Quota
      </label>
      
      {error && (
        <div className="flex items-center p-3 text-sm bg-red-50 border border-red-200 rounded-md text-red-800">
          <AlertCircle className="w-4 h-4 mr-2 flex-shrink-0" />
          <span>{error}</span>
        </div>
      )}
      
      <div className="relative">
        {loading && (
          <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
            <Loader2 className="w-4 h-4 animate-spin text-gray-400" />
          </div>
        )}
        
        <select
          id="quota-select"
          value={quotaId}
          onChange={handleQuotaChange}
          className={`
            block w-full px-3 py-2 bg-white border rounded-md shadow-sm 
            focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500
            disabled:bg-gray-100 disabled:text-gray-500 disabled:cursor-not-allowed
            ${error ? 'border-red-300' : 'border-gray-300'}
          `}
          disabled={loading || options.length === 0}
        >
          {options.length === 0 ? (
            <option value="">No quotas available</option>
          ) : (
            options.map((option) => (
              <option key={option.quota_id} value={option.quota_id}>
                {option.title || "Unnamed Quota"}
              </option>
            ))
          )}
        </select>
      </div>
      
      {!loading && options.length === 0 && !error && coursesId && (
        <p className="text-sm text-gray-500">
          No quotas are available for this course.
        </p>
      )}
    </div>
  );
};

export default QuotaList;